var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.566 11.24L4.427 5.748A.5.5 0 014.862 5h6.276a.5.5 0 01.434.748L8.434 11.24a.5.5 0 01-.868 0z",
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjU2NTg4IDExLjI0MDNMNC40Mjc0NyA1Ljc0ODA3QzQuMjM3IDUuNDE0NzQgNC40Nzc2OCA1IDQuODYxNTkgNUw4IDVMMTEuMTM4NCA1QzExLjUyMjMgNSAxMS43NjMgNS40MTQ3NCAxMS41NzI1IDUuNzQ4MDdMOC40MzQxMiAxMS4yNDAzQzguMjQyMTcgMTEuNTc2MiA3Ljc1NzgzIDExLjU3NjIgNy41NjU4OCAxMS4yNDAzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgTriangleDown as ReactComponent };